import React from 'react';
import ProductDetails from '../components/ProductDetails';
import PageTransition from '../components/PageTransition';

function ProductDetailsPage() {
  return <ProductDetails />;
}

export default PageTransition(ProductDetailsPage);
